<template>
    <div>
        <base-crud
                crudName="Temas"
                newText="Novo Tema"
                :table="themeTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="false"
        >
        </base-crud>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function() {
    return {
      themeTable: "themeTable",
      teams: [],
      pages: [],
      url: "",
      columns: ["id", "photo", "title", "document", 'question', "actions"],
      tableData: ["id", "title", "photo", "document", 'question'],
      options: {
        filterable:["id", "title", "document", "question"],
        filterByColumn: true,                           
        sortable: ["id", "title"],
        templates: {
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          title: "Título",
          photo: "Foto",
          document: "Documento",
          question: "Perguntas",
          actions: "Ações"
        },
        requestFunction: function(data) {
          let requestData = {};

           let query = this.$parent.$parent.query(data.query);
           requestData.params = data;
           requestData.params.query = "";
           requestData.params.with = [];

          return this.$http
              .get(this.url + '?' + query, requestData)
              .catch(
                  function(e) {
                      this.dispatch("error", e);
                  }.bind(this)
              );
        }
      },
      endPoint: "themes/"
    };
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        title: "title",
        document: "document",
        question: "question",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    }
  },
  components: {
    BaseCrud
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Theme/Crud.vue